<!-- ===== REFONTE : feuille de présence d'une activité ===== -->
<div class="fp-page">
  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

  <div class="fp-alerte" role="alert" *ngIf="erreur">
    <span>{{ erreur }}</span>
    <button
      type="button"
      class="fp-alerte__fermer"
      aria-label="Fermer"
      (click)="erreur = null"
    >
      ×
    </button>
  </div>

  <div class="fp-carte" *ngIf="activity as activite">
    <!-- ===== En-tête : bandeau rouge, propre à la feuille de présence ===== -->
    <div class="fp-bandeau">
      <div class="fp-bandeau__texte">
        <h1 class="fp-grand-titre">Feuille de présence</h1>
        <p class="fp-sous-titre">{{ activite.nomActivity }}</p>
        <div class="fp-ligne-infos">
          <span class="fp-tag fp-tag--type">{{ libelleType }}</span>
          <span class="fp-tag">
            <svg
              class="fp-drapeau"
              viewBox="0 0 30 20"
              aria-hidden="true"
              [ngSwitch]="codePays"
            >
              <g *ngSwitchCase="'bj'">
                <rect width="30" height="10" fill="#fcd116" />
                <rect y="10" width="30" height="10" fill="#e8112d" />
                <rect width="12" height="20" fill="#008751" />
              </g>
              <g *ngSwitchDefault>
                <rect width="10" height="20" fill="#00853f" />
                <rect x="10" width="10" height="20" fill="#fdef42" />
                <rect x="20" width="10" height="20" fill="#e31b23" />
                <polygon
                  points="15,6.2 16.1,9.4 19.4,9.4 16.7,11.4 17.7,14.6 15,12.6 12.3,14.6 13.3,11.4 10.6,9.4 13.9,9.4"
                  fill="#00853f"
                />
              </g>
            </svg>
            {{ libellePays }}
          </span>
          <span
            class="fp-tag"
            [ngClass]="estFermee ? 'fp-tag--fermee' : 'fp-tag--ouverte'"
          >
            {{ estFermee ? "Fermée" : "Ouverte" }}
          </span>
          <span class="fp-info" *ngIf="activite.openDate">
            {{ activite.openDate | date: "d MMM y" : "" : "fr" }}
            <ng-container
              *ngIf="
                activite.closeDate && activite.closeDate !== activite.openDate
              "
            >
              → {{ activite.closeDate | date: "d MMM y" : "" : "fr" }}
            </ng-container>
          </span>
          <span class="fp-info" *ngIf="activite.adresse">{{
            activite.adresse
          }}</span>
        </div>
      </div>
      <div class="fp-actions">
        <button
          type="button"
          class="fp-btn fp-btn--secondaire"
          (click)="exportTable()"
          [disabled]="!participantsFiltres.length"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="M12 3v12M7 10l5 5 5-5M5 21h14" />
          </svg>
          Exporter en Excel
        </button>
        <button
          type="button"
          class="fp-btn fp-btn--pdf"
          (click)="exportPDF()"
          [disabled]="generationPdf || !participants.length"
        >
          <svg
            *ngIf="!generationPdf"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path
              d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5zM14 3v5h5M9 13h6M9 17h6"
            />
          </svg>
          <span
            class="fp-rond fp-rond--blanc"
            *ngIf="generationPdf"
            aria-hidden="true"
          ></span>
          {{ generationPdf ? "Génération du PDF…" : "Exporter en PDF" }}
        </button>
      </div>
    </div>

    <!-- ===== Chiffres : une seule bande, différente des cartes des confirmations ===== -->
    <div class="fp-chiffres">
      <div class="fp-chiffre">
        <span class="fp-chiffre__nombre">{{ nbPresents }}</span>
        <span class="fp-chiffre__libelle">présent(s)</span>
      </div>
      <div class="fp-chiffre fp-chiffre--genre">
        <div class="fp-genres">
          <span
            ><b class="fp-txt-f">{{ nbFemmes }}</b> femmes ·
            {{ pourcentage(nbFemmes) }} %</span
          >
          <span
            ><b class="fp-txt-h">{{ nbHommes }}</b> hommes ·
            {{ pourcentage(nbHommes) }} %</span
          >
        </div>
        <div class="fp-repartition" aria-hidden="true">
          <i
            class="fp-repartition--f"
            [style.width.%]="pourcentage(nbFemmes)"
          ></i>
          <i
            class="fp-repartition--h"
            [style.width.%]="pourcentage(nbHommes)"
          ></i>
        </div>
      </div>
      <div class="fp-chiffre">
        <span
          class="fp-chiffre__nombre"
          [class.fp-alerte-texte]="nbSansTelephone > 0"
          >{{ nbSansTelephone }}</span
        >
        <span class="fp-chiffre__libelle">
          {{
            nbSansTelephone
              ? "sans téléphone : paiement impossible"
              : "sans téléphone"
          }}
        </span>
      </div>
    </div>

    <p class="fp-vide" *ngIf="!chargement && !participants.length">
      Personne n'a encore été marqué présent à cette activité.
    </p>

    <ng-container *ngIf="participants.length">
      <!-- ===== Filtres ===== -->
      <div class="fp-outils">
        <div class="fp-filtres" role="group" aria-label="Filtrer par genre">
          <button
            type="button"
            class="fp-filtre"
            [class.fp-filtre--actif]="filtre === 'tous'"
            (click)="choisirFiltre('tous')"
          >
            Tous <b>{{ nbPresents }}</b>
          </button>
          <button
            type="button"
            class="fp-filtre"
            [class.fp-filtre--actif]="filtre === 'femmes'"
            (click)="choisirFiltre('femmes')"
          >
            Femmes <b>{{ nbFemmes }}</b>
          </button>
          <button
            type="button"
            class="fp-filtre"
            [class.fp-filtre--actif]="filtre === 'hommes'"
            (click)="choisirFiltre('hommes')"
          >
            Hommes <b>{{ nbHommes }}</b>
          </button>
        </div>
        <label class="fp-recherche">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            aria-hidden="true"
          >
            <circle cx="11" cy="11" r="7" />
            <path d="M20 20l-3.5-3.5" />
          </svg>
          <input
            type="text"
            [formControl]="searchCtrl"
            placeholder="Nom, email, téléphone, adresse…"
            aria-label="Rechercher un participant"
          />
        </label>
      </div>

      <!-- ===== Tableau ===== -->
      <div class="fp-tableau">
        <table>
          <thead>
            <tr>
              <th>Participant</th>
              <th>Genre</th>
              <th>Téléphone</th>
              <th>Adresse</th>
              <th>Présent le</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of pageCourante">
              <td class="fp-qui">
                <b>{{ (nomComplet(p) | titlecase) || "—" }}</b>
                <span>{{ p.email }}</span>
              </td>
              <td>
                <span
                  class="fp-genre"
                  [ngClass]="
                    genre(p) === 'F'
                      ? 'fp-genre--f'
                      : genre(p) === 'H'
                        ? 'fp-genre--h'
                        : 'fp-genre--nr'
                  "
                  >{{ libelleGenre(p) }}</span
                >
              </td>
              <td class="fp-nowrap">
                <span *ngIf="telephone(p); else sansTel">{{
                  telephone(p)
                }}</span>
                <ng-template #sansTel
                  ><span class="fp-manquant">Pas de numéro</span></ng-template
                >
              </td>
              <td>{{ p.address || "—" }}</td>
              <td class="fp-nowrap">
                <ng-container *ngIf="horodatage(p) as h; else sansHeure">
                  <b class="fp-heure">{{ h.heure }}</b>
                  <span class="fp-jour">{{ h.jour }}</span>
                </ng-container>
                <ng-template #sansHeure
                  ><span class="fp-gris">—</span></ng-template
                >
              </td>
            </tr>
            <tr *ngIf="!pageCourante.length">
              <td colspan="5" class="fp-vide">
                Aucun participant ne correspond à ta recherche.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="fp-pied">
        <span
          >Lignes {{ premiereLigne }} à {{ derniereLigne }} sur
          {{ participantsFiltres.length }}</span
        >
        <div class="fp-pagination">
          <button
            type="button"
            class="fp-btn fp-btn--secondaire fp-btn--petit"
            [disabled]="currentPage === 1"
            (click)="previousPage()"
          >
            Précédent
          </button>
          <span>Page {{ currentPage }} sur {{ totalPages }}</span>
          <button
            type="button"
            class="fp-btn fp-btn--secondaire fp-btn--petit"
            [disabled]="currentPage === totalPages"
            (click)="nextPage()"
          >
            Suivant
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- ===== Aperçu du PDF, dans la page ===== -->
<div class="fp-overlay" *ngIf="pdfUrl" (click)="fermerPdf()">
  <div
    class="fp-apercu"
    role="dialog"
    aria-modal="true"
    aria-labelledby="fp-apercu-titre"
    (click)="$event.stopPropagation()"
  >
    <div class="fp-apercu__entete">
      <div>
        <h3 id="fp-apercu-titre">Feuille de présence (PDF)</h3>
        <p>{{ activity?.nomActivity }} · {{ nbPresents }} présent(s)</p>
      </div>
      <div class="fp-actions">
        <button
          type="button"
          class="fp-btn fp-btn--secondaire"
          (click)="imprimerPdf()"
        >
          Imprimer
        </button>
        <button
          type="button"
          class="fp-btn fp-btn--primaire"
          (click)="telechargerPdf()"
        >
          Télécharger
        </button>
        <button
          type="button"
          class="fp-btn fp-btn--secondaire fp-btn--icone"
          aria-label="Fermer l'aperçu"
          (click)="fermerPdf()"
        >
          ✕
        </button>
      </div>
    </div>
    <iframe
      #cadrePdf
      class="fp-apercu__cadre"
      [src]="pdfUrl"
      title="Aperçu de la feuille de présence"
    ></iframe>
  </div>
</div>
<!-- ===== FIN REFONTE ===== -->
